import { ITagResult } from '../../../httpClient/serverApi/types/IResponse';
import { TagRequest } from './TagRequest';

import { IAnalyticsConnectionMapping } from '../../../settings/types/ISiteSettingsForSiteAdmin';

export type ISetAnalyticsExtConnectionForWorkbookResult = ITagResult;

export class SetAnalyticsExtConnectionForWorkbookRequest extends TagRequest<IAnalyticsConnectionMapping, ISetAnalyticsExtConnectionForWorkbookResult> {
  constructor(params: IAnalyticsConnectionMapping) {
    super('analyticsextensions', 'updateWorkbookWithConnection', params);
  }
}
